import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceReviewForm from './ServiceReviewForm'

import { updateServiceReview } from '../services'
import { handleError } from '../../../helpers'

export default function EditServiceReviewModal({ visible, onClose, serviceReview, reload, editable = {} }) {
	const { handleSubmit, register, formState: { errors }, setValue } = useForm({ 
		defaultValues: {
			sku: serviceReview.sku,
			format_code: serviceReview.format_code,
			format_version: serviceReview.format_version,
			valid_until: serviceReview.valid_until,
		}
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		delete values.sku
		updateServiceReview(serviceReview.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ServiceReviewForm 
						register={register}
						errors={errors}
						setValue={setValue}
						editable={editable}
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}